import { Link } from 'react-router-dom';
import type { ContentItem } from '@/mocks/content';
import { formatShortDate, formatViews } from '@/utils/content';

interface ContentListItemProps {
  item: ContentItem;
  showImage?: boolean;
}

export default function ContentListItem({ item, showImage = true }: ContentListItemProps) {
  return (
    <article className="group flex gap-4 border-b border-background-200/70 py-5 last:border-0 md:gap-6">
      {showImage && (
        <Link
          to={`/detail/${item.id}`}
          className="relative h-24 w-32 flex-shrink-0 overflow-hidden rounded-lg bg-background-200 md:h-28 md:w-44"
        >
          <img
            src={item.image}
            alt={item.title}
            title={`${item.title} - ${item.tag}`}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </Link>
      )}
      <div className="flex min-w-0 flex-1 flex-col justify-between">
        <div>
          <div className="mb-2 flex items-center gap-2">
            <span className="rounded bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-900">
              {item.tag}
            </span>
            <span className="text-xs text-foreground-500">{item.categoryName}</span>
          </div>
          <h3 className="mb-2">
            <Link
              to={`/detail/${item.id}`}
              className="line-clamp-2 font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors hover:text-primary-600 md:text-lg"
            >
              {item.title}
            </Link>
          </h3>
          <p className="line-clamp-2 text-sm leading-relaxed text-foreground-600">
            {item.summary}
          </p>
        </div>
        <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
          <span className="whitespace-nowrap">
            <i className="ri-user-line mr-1"></i>
            {item.author}
          </span>
          <span className="whitespace-nowrap">
            <i className="ri-calendar-line mr-1"></i>
            {formatShortDate(item.date)}
          </span>
          <span className="whitespace-nowrap">
            <i className="ri-fire-line mr-1"></i>
            {formatViews(item.views)}
          </span>
        </div>
      </div>
    </article>
  );
}